import BaseModel from "../models/BaseModel";
import BaseModelMap from "../models/BaseModelMap";
import TreeViewModel from "../models/TreeviewModel";
import TreeNodeInfo from "../models/TreeNodeInfo";
import { isUiModeDeveloper, isUiModeExpert } from "../uiMode";
import { fixedPageGroupTags } from "../models/PageGroup";

export default class RootTreeViewModel extends TreeViewModel {
  get typedObj(): BaseModelMap<BaseModel> {
    return this.obj as BaseModelMap<BaseModel>;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return true;
  }

  getChildCollectionEx(parentTreeNodeInfo: TreeNodeInfo): Array<TreeNodeInfo> | undefined {
    const res = [
      new TreeNodeInfo(undefined, state.floors),
      new TreeNodeInfo(undefined, state.cabinets),
      new TreeNodeInfo(undefined, state.templateGroups),
      new TreeNodeInfo(undefined, state.c1.catalog.definitions.roots),
      new TreeNodeInfo(undefined, state.addresses),
      new TreeNodeInfo(undefined, state.sceneGroup),
    ];

    if (state.projectMetadata.isC1Project && !isUiModeDeveloper()) {
      const buildingPlans = state.pageGroups.findFirst(group => group.tag === fixedPageGroupTags.buildingPlans);
      if (buildingPlans && (buildingPlans.pages.size > 0 || buildingPlans.pageGroups.size > 0)) {
        res.push(new TreeNodeInfo(undefined, buildingPlans));
      }
    } else {
      res.push(new TreeNodeInfo(undefined, state.pageGroups));
    }
    res.push(new TreeNodeInfo(undefined, state.topologies));

    if (state.settings.showCabinetPlaning && isUiModeExpert()) {
      res.push(new TreeNodeInfo(undefined, state.cableTypes));
    }

    if (state.objectSets.size > 0 && isUiModeDeveloper()) {
      res.push(new TreeNodeInfo(undefined, state.objectSets));
    }

    return res;
  }

  getButtons(): JSX.Element[] | undefined {
    return [];
  }
}
